var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"z-index":"1"}},[_c('app-bar'),_c('v-main',[_c('v-container',[_c('router-view')],1)],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }